import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowsRotate,
  faBars,
  faBuilding,
  faCalendar,
  faCheck,
  faChevronRight,
  faCog,
  faEmptySet,
  faEnvelope,
  faFolder,
  faFolderOpen,
  faFolders,
  faGauge,
  faGlobe,
  faHome,
  faListCheck,
  faLocationDot,
  faMagnifyingGlass,
  faMapLocationDot,
  faPaperPlane,
  faPencil,
  faQuestion,
  faSearch,
  faSitemap,
  faStar,
  faSubtitles,
  faTasks,
  faTrash,
  faTreePalm,
  faUser,
  faUserCrown,
  faUsers,
  faVirus
} from '@fortawesome/pro-light-svg-icons'
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons'

export const icons = [
  faArrowsRotate,
  faBars,
  faBuilding,
  faChevronRight,
  faCog,
  faEnvelope,
  faFolder,
  faFolderOpen,
  faFolders,
  faGauge,
  faGlobe,
  faMagnifyingGlass,
  faMapLocationDot,
  faPencil,
  faSitemap,
  faSubtitles,
  faTrash,
  faTreePalm,
  faUser,
  faUserCrown,
  faUsers,
  faVirus,
  faPaperPlane,
  faCheck,
  faEmptySet,
  faSearch,
  faLocationDot,
  faListCheck,
  faCircleExclamation,
  faBuilding,
  faHome,
  faStar,
  faTasks,
  faCalendar,
  faQuestion
]

library.add(...icons)
